import Grid from '@mui/material/Grid';
import styles from 'assets/css/Hypo.module.css';
import {digitsEnToFa} from 'persian-tools2';
import {usePatientInfo} from '../../../../hooks/usePatient';

export const HypoglycemiaList = (props) => {
  const {total, level1, level2, nocturnal} =
    props !== {} && props?.HypoglycemiaListData;
  const {data: patientInfo} = usePatientInfo(props?.patientId);
  const {isPregnant} = patientInfo || {};

  const data = [
    {
      labelBold: 'تعداد کل ',
      label: '  رویداد های هایپوگلیسمی',
      value: total ? digitsEnToFa(total) : '_',
    },
    {
      labelBold: 'سطح ۱ ',
      label: ` هایپوگلیسمی`,
      value: level1 ? digitsEnToFa(level1) : '_',
      ltrText: `${digitsEnToFa(`(۵۴ ≤ BS <${isPregnant ? '۶۰' : '۷۰'})`)}`,
    },
    {
      labelBold: 'سطح ۲ ',
      label: ' هایپوگلیسمی',
      value: level2 ? digitsEnToFa(level2) : '_',
      ltrText: `${digitsEnToFa('(۵۴ < BS)')}`,
    },
    {
      ltrText: 'شبانه',
      label: 'رویداد های هایپوگلیسمی',
      value: nocturnal ? digitsEnToFa(nocturnal) : '_',
    },
  ];

  const LineSeparator = () => {
    return (
      <div
        style={{
          border: '1.75px solid #FFFFFF',
          margin: 'auto',
          width: '100%',
          height: '0px',
          background: '#FFFFFF',
          marginTop: '7px',
          marginBottom: '13px',
        }}
      />
    );
  };

  return (
    <Grid container style={{padding: '0 16px 21px 16px'}} dir='ltr'>
      <p className={styles.partTitleEvent}>: رویداد های هایپوگلیسمی</p>
      {data.map(({labelBold, label, value, ltrText}, index) => (
        <Grid
          container
          alignItems='center'
          justifyContent='space-between'
          key={index}>
          <Grid item xs={1.5} textAlign='left'>
            <span className={styles.hypoValues}>{value}</span>
          </Grid>
          <Grid item xs={10.5} textAlign='right' dir='rtl'>
            <span
              style={{fontFamily: 'dana-bold'}}
              className={styles.hypoLabels}>
              {labelBold}
            </span>
            <span className={styles.hypoLabels}>
              {ltrText ? (
                <>
                  {label}{' '}
                  <span
                    dir='ltr'
                    style={{fontFamily: index === 3 && 'dana-bold'}}>
                    {ltrText}
                  </span>
                </>
              ) : (
                `${label}`
              )}
            </span>{' '}
            :
          </Grid>
          {index !== 3 && <LineSeparator />}
        </Grid>
      ))}
    </Grid>
  );
};
